import { useCallback, useState } from "react";

import { formatCpf, stripCpf, formatCnpj, stripCnpj } from "../../utils";

const useMask = (initialValue) => {
  const [mask, setMask] = useState(initialValue);

  const applyMask = useCallback(
    (value) => {
      if (!mask || !value) {
        return value;
      }

      switch (mask) {
        case "cpf":
          return {
            inputValue: formatCpf(value, true),
            dataValue: stripCpf(value, true),
          };
        case "cnpj":
          return {
            inputValue: formatCnpj(value, true),
            dataValue: stripCnpj(value, true),
          };
        case "cpf/cnpj": {
          const onlyNumbers = value?.replace(/\D/gi, "");
          const format = onlyNumbers?.length <= 11 ? formatCpf : formatCnpj;
          const strip = onlyNumbers?.length <= 11 ? stripCpf : stripCnpj;
          return {
            inputValue: format(onlyNumbers, onlyNumbers?.length > 11),
            dataValue: strip(onlyNumbers, onlyNumbers?.length > 11),
          };
        }

        default: {
          const { patterIn, patterOut } = mask;
          const pattern = new RegExp(patterIn, "ig");
          return {
            inputValue: value.replace(pattern, patterOut),
            dataValue: value,
          };
        }
      }
    },
    [mask]
  );

  return { applyMask, setMask };
};

export default useMask;
